import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    root: {
      position: 'fixed',
      height: 'calc(100vh - 65px)',

      width: 400,
      [theme.breakpoints?.down('sm')]: {
        height: 'calc(100vh )',
        left: 57,
        top: 57
      }

    }
  }
)
const PREFIX = 'UseMinimapStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const UseMinimapStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  UseMinimapStyle
}
